var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorDuration = function SvgIconArtGeneratorDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.317 2.001a.667.667 0 0 1-.503.798q-.195.044-.389.104a.667.667 0 0 1-.393-1.274q.24-.075.487-.13A.667.667 0 0 1 7.317 2m1.366 0a.667.667 0 0 1 .798-.502A6.667 6.667 0 1 1 1.499 9.48a.667.667 0 0 1 1.3-.295A5.334 5.334 0 1 0 9.185 2.8a.667.667 0 0 1-.502-.798M4.41 3.147a.666.666 0 0 1-.035.942 5 5 0 0 0-.285.284.667.667 0 0 1-.977-.906q.17-.184.355-.356a.667.667 0 0 1 .942.036M8 4a.667.667 0 0 1 .667.667v3.057L10.47 9.53a.667.667 0 0 1-.942.942l-2-2a.67.67 0 0 1-.196-.47V4.666A.667.667 0 0 1 8 4M2.462 5.592a.667.667 0 0 1 .44.833q-.059.193-.103.39a.667.667 0 0 1-1.3-.296q.055-.246.13-.486a.667.667 0 0 1 .833-.44",
    clipRule: "evenodd"
  })));
};
export default SvgIconArtGeneratorDuration;